import { render, staticRenderFns } from "./MasterBrands.vue?vue&type=template&id=04b54aee&"
import script from "./MasterBrands.vue?vue&type=script&lang=js&"
export * from "./MasterBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports